import type { SVGProps } from 'react';
const SvgAntelope = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39 39" {...props}>
    <path d="M8.259 21.643h7.5a10.54 10.54 0 0 1-3.214-8.572A9.73 9.73 0 0 1 21.116 4.5c.986 0 2.143 0 2.143 1.071 0 1.072-.964 1.072-2.143 1.072-2.143 0-3.214 4.286-3.214 6.428 0 4.286 7.5 9.643 7.5 9.643L31.83 27l-4.286 7.5a70 70 0 0 0-8.572-7.5A99 99 0 0 0 8.26 23.786a1.136 1.136 0 0 1 0-2.143" />
  </svg>
);
export default SvgAntelope;
